import React from 'react'
import styled from 'styled-components'
import { spacing } from 'frontend_core/dist/styles/variables'
import { mediaMax } from 'styles/media'
import AccountTemplate from 'components/templates/AccountTemplate'
import LoadingView from 'components/atoms/LoadingView'
import FormButtonGroup from 'components/molecules/FormButtonGroup'
import EventNotificationForm from 'components/organisms/EventNotificationForm'

const Inner = styled.div`
  padding: 0 ${spacing.small_3}px;
`

const ButtonContainer = styled.div``
const FormContainer = styled.div`
  margin: ${spacing.huge}px 0;
  &::after {
    content: '';
    clear: both;
    display: block;
  }
`

const Wrapper = styled.div`
  width: 100%;
  max-width: 810px;
  margin: 0 auto;
  padding: 0 0 ${spacing.huge}px;
  position: relative;
  &::after {
    content: '';
    clear: both;
    display: block;
  }
`

const HintWrapper = styled.div`
  float: right;
  width: 250px;
`

const Main = styled.div`
  ${mediaMax.phone`
    max-width: none;
  `};
`

const MainWrapper = styled.div`
  float: left;
  width: 500px;
`

export default props => (
  <AccountTemplate
    title={props.title}
    description={props.description}
    currentUser={props.currentUser}
    breadcrumbs={props.breadcrumbs}
    config={props.config}
  >
    {props.isLoading && <LoadingView />}
    <Inner>
      <Wrapper>
        <FormContainer>
          <MainWrapper>
            <Main>
              <EventNotificationForm
                onSubmit={props.onSubmit}
                onChange={props.onChange}
                setting={props.setting}
              />
            </Main>
          </MainWrapper>
          <HintWrapper />
        </FormContainer>
        <ButtonContainer>
          <FormButtonGroup
            onSubmit={props.onSubmit}
            onClickBack={props.onClickBack}
            isBackButtonDisabled={props.isBackButtonDisabled}
            isSubmitButtonDisabled={props.isSubmitButtonDisabled}
          />
        </ButtonContainer>
      </Wrapper>
    </Inner>
  </AccountTemplate>
)
